import fields from '@src/entities/ActionPath/includes/fields.json';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';
import React from 'react';

const { scopeCode: scopeCodeField } = fields;

/**
 * Field: ScopeCode
 *
 * Choose how the actions should be applied to the action path.
 *
 * @param form
 * @returns {Element}
 * @constructor
 */
export function ScopeCode({
  form = {
    validate: () => {},
  },
}) {
  return (
    <ErrorHandler location="src/features/ActionPaths/Wizard/components/fields/ScopeCode/ScopeCode.jsx">
      <RadioGroup
        {...scopeCodeField}
        css={{
          'abyss-radio-group-root': {
            marginTop: '0 !important',
          },
        }}
        onChange={() => {
          form?.validate(
            `remediation[actionPathScopeCode]`,
            () => {},
            () => {}
          );
        }}
      >
        {scopeCodeField?.options?.map((option) => {
          return <RadioGroup.Radio key={option.value} {...option} />;
        })}
      </RadioGroup>
    </ErrorHandler>
  );
}
